module.exports = __webpack_public_path__ + "static/media/chevron-right.974f0cec.svg";